import { render, staticRenderFns } from "./IntelligenceProviderCompetitionTable.vue?vue&type=template&id=3a1b34e4&scoped=true"
import script from "./IntelligenceProviderCompetitionTable.vue?vue&type=script&lang=js"
export * from "./IntelligenceProviderCompetitionTable.vue?vue&type=script&lang=js"
import style0 from "./IntelligenceProviderCompetitionTable.vue?vue&type=style&index=0&id=3a1b34e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1b34e4",
  null
  
)

export default component.exports